import { render, staticRenderFns } from "./PcBannerList.vue?vue&type=template&id=456ef56c&scoped=true"
import script from "./PcBannerList.vue?vue&type=script&lang=js"
export * from "./PcBannerList.vue?vue&type=script&lang=js"
import style0 from "./PcBannerList.vue?vue&type=style&index=0&id=456ef56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ef56c",
  null
  
)

export default component.exports